var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view--guide-list"},[_c('guide-list-header',{attrs:{"show-guide-create":_vm.showGuideCreate},on:{"showGuideCreateChange":_vm.handleGuideCreateChange}}),_c('guide-list-content',{on:{"showGuideCreateChange":_vm.handleGuideCreateChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }